<template>
  <div class="pubMedChart">
    <viewHeader></viewHeader>
    <div class="content" v-loading="loading" element-loading-text="拼命加载中">
      <el-card class="box-card" shadow="never" v-show="hasData">
        <div slot="header" class="clearfix">
          <el-row>
            <el-col :span="10">
              <img src="../assets/img/icon0.png" alt="" class="L" />
              <span class="L"
                >{{ title_word }}<br /><em
                  >为您找到 {{ beforeNumFound }} 篇文献</em
                ></span
              >
            </el-col>
            <el-col :span="5" class="searchInput">
              分析前
              <el-input size="small" v-model="num_summary"></el-input> 篇文献
            </el-col>
            <el-col :span="5" class="searchInput">
              概述前
              <el-input size="small" v-model="num_overview"></el-input> 篇文献
            </el-col>
            <el-col :span="4">
              <el-button
                class="R searchButton"
                size="small"
                type="text"
                @click="getAnalysis"
                >分析</el-button
              >
            </el-col>
          </el-row>
        </div>
        <p class="actualNum">
          根据实际结果，已为您分析出前
          <span>{{ actual_num_overview }}</span> 篇文献，概述前
          <span>{{ actual_num_detail }}</span> 篇文献
        </p>
        <div class="introduce" v-show="hasFenxi">
          <h2 class="title clearfix">
            <span class="L"></span><em class="L">文献分析</em>
          </h2>
          <el-tabs type="border-card">
            <el-tab-pane
              :label="item.section_name"
              lazy
              v-for="(item, index) in chart"
              :key="'tab' + index"
            >
              <span slot="label" style="position: relative">
                {{ item.section_name }}
                <!-- <el-badge :value="12" class="badge-a"/> -->
              </span>
              <ol class="bullet_point">
                <li
                  v-for="(point, pointIndex) in item.bullet_points"
                  :key="'point' + pointIndex"
                  class="clearfix"
                >
                  <span class="L"></span>
                  <em class="L">{{ point }}</em>
                </li>
              </ol>
              <div
                v-for="(chart, chartIndex) in item.charts"
                :key="'bar' + chartIndex"
              >
                <p v-if="item.section_name !== '医学情报'" class="keyType">
                  {{ chart.chart_title }}
                </p>
                <ve-bar
                  v-if="item.section_name !== '医学情报'"
                  :data="chart.chartData"
                  :extend="chartExtend"
                  :legend-visible="false"
                >
                </ve-bar>
              </div>
              <div
                v-for="(chart, chartIndex) in item.charts"
                :key="'word' + chartIndex"
              >
                <p v-if="item.section_name === '医学情报'" class="keyType">
                  {{ chart.chart_title }}
                </p>
                <ve-wordcloud
                  v-if="item.section_name === '医学情报'"
                  :data="chart.chartData"
                >
                </ve-wordcloud>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="introduce resultList" v-show="hasOver">
          <h2 class="title clearfix">
            <span class="L"></span><em class="L">文献概述</em>
          </h2>
          <el-timeline :reverse="reverse">
            <el-timeline-item
              :color="color"
              icon="el-icon-loading"
              v-for="(value, key) in timeData"
              :key="key"
            >
              <p class="timeLine">{{ key }}</p>
              <ul>
                <li
                  v-for="(item, index) in value"
                  :key="index"
                  class="infoLi"
                  v-loading="item.loading"
                >
                  <el-row :gutter="20" class="listTitle">
                    <el-col :span="24" class="title">
                      {{ item.title }}
                      <img v-show="item.is_download"  class="pptIcon" src="../assets/img/ppt.png" alt="">
                    </el-col>
                  </el-row>
                  <el-row class="listInfo">
                    <el-col :span="20"
                      ><span>PMID：</span>{{ item.pmid }}</el-col
                    >
                    <el-col :span="20">
                      <span>作者：</span>
                      <em
                        v-for="(author, authorIndex) in item.authors"
                        :key="authorIndex"
                        >{{ author
                        }}<i v-if="authorIndex + 1 < item.authors.length">
                          、</i
                        ></em
                      >
                    </el-col>
                    <el-col :span="20"
                      ><span>期刊：</span>{{ item.journal }}</el-col
                    >
                    <el-col
                      :span="20"
                      v-if="item.impact_factor && item.impact_factor !== ''"
                      ><span>影响因子：</span>{{ item.impact_factor }}</el-col
                    >
                    <el-col :span="20">
                      <span>标签：</span>
                      <em v-for="(tag, tagIndex) in item.tags" :key="tagIndex"
                        >{{ tag
                        }}<i v-if="tagIndex + 1 < item.tags.length"> 、</i></em
                      >
                    </el-col>
                    <el-col :span="20">
                      <span>关键词：</span>
                      <em
                        v-for="(keyword, keywordIndex) in item.keywords"
                        :key="keywordIndex"
                        >{{ keyword
                        }}<i v-if="keywordIndex + 1 < item.keywords.length">
                          、</i
                        ></em
                      >
                    </el-col>
                    <el-col :span="20"
                      ><span>主要结论：</span
                      >{{ item.major_conclusion }}</el-col
                    >
                  </el-row>
                  <el-row>
                    <el-col :span="4" class="clearfix">
                      <img src="../assets/img/chart3.png" alt="" class="L" />
                      <el-link
                        href="javascript:;"
                        class="L showMore"
                        @click.native="showFullText(item.pmid)"
                        >查看更多</el-link
                      >
                    </el-col>
                    <el-col :span="4" class="clearfix">
                      <img src="../assets/img/chart4.png" alt="" class="L" />
                      <el-link
                        href="javascript:;"
                        class="L translate"
                        @click.native="
                          translateFullText(
                            item.pmid,
                            key,
                            index,
                            item.translate
                          )
                        "
                        >翻译重点信息</el-link
                      >
                    </el-col>
                  </el-row>
                </li>
              </ul>
            </el-timeline-item>
          </el-timeline>
        </div>
      </el-card>
      <div class="noData" v-show="!hasData">
        <img src="../assets/img/empty.png" alt="" />
        <span>空空如也，没有找到需要分析的文献哦~</span>
      </div>
    </div>
    <!-- <div class="progressBox" v-show="loading">
            <div class="shadow"></div>
            <el-progress :text-inside="true" :stroke-width="4" :percentage="percent"></el-progress>
        </div> -->
  </div>
</template>

<script>
import { md5 } from "md5js";
import { analysis, translateInfo } from "../service/getData";
import viewHeader from "./viewHeader";
import { webTrackerEvent } from "../utils/tracker";
export default {
  name: "pubMedChart",
  components: {
    viewHeader,
  },
  data() {
    this.chartSettings = {
      // dimension: ['年份'],
      // metrics: ['文章数'],
    };
    return {
      hasData: true,
      secret: "4ede4aafbzd51cbz3e32bzb781bzee9813d17154",
      clientId: "zeta",
      loading: true,
      reverse: false,
      color: "#3cabd5",
      timeData: {},
      chart: [],
      chartExtend: {
        color: "#75a1f7",
        series: {
          // barWidth: 20,
          barMaxWidth: 20,
          // barGap: '30%'
          // label:{ show: true }
        },
      },
      searchType: "normal", // 分析文献的类型 normal/drug/disease/advanced
      beforeNumFound: 0, // 分析之前的文献总数
      keyword: "",
      title_word: "",
      scope: [], // 针对疾病和药品
      sortText: "",
      num_summary: 500, // 分析前多少篇文献
      num_overview: 50, // 概述前多少篇文献
      titleJson: {},
      hasFenxi: true, // 是否存在文献分析
      hasOver: true, // 是否存在文献概述
      percent: 0,
      actual_num_detail: 0, // 实际分析数量
      actual_num_overview: 0, // 实际概述数量
      token: window.localStorage.getItem("PUBMEDSEARCHTOKEN"),
      openid: window.localStorage.getItem("PUBMEDSEARCHOPENID"),
    };
  },
  methods: {
    // 文献分析总结
    async getAnalysis() {
      if (this.num_summary > 5000 || this.num_overview > 500) {
        this.$alert(
          "数量超过上限>_<，分析数量最多不能超过5000，概述数量最多不能超过500哦",
          "提示",
          {
            confirmButtonText: "确定",
          }
        );
        return;
      }
      this.loading = true;
      this.percent = 0;
      const params = {
        search_type: this.searchType,
        numFound: this.beforeNumFound,
        keyword: this.keyword,
        scope: this.scope,
        filters: this.filter,
        sort: this.sortText,
        num_summary: Number(this.num_summary),
        num_overview: Number(this.num_overview),
      };

      let Logger = webTrackerEvent();
      if (this.searchType && this.searchType == "advanced") {
        Logger.push("search_type", "precise");
      } else {
        Logger.push("search_type", "normal");
      }
      Logger.push("page_url", window.location.href);
      Logger.push("action", "pubMedChart");
      Logger.push("search_keyword", this.keyword);
      Logger.push("search_filter", JSON.stringify(this.filter));
      Logger.push("search_sort", this.sortText);
      Logger.push("token", this.token);
      Logger.push("openid", this.openid);
      Logger.logger();

      const res = await analysis(params, this.progress);
      let timer = null;
      if (res && res.data.status === 0) {
        if (res.data.actual_num_detail) {
          this.actual_num_detail = res.data.actual_num_detail;
        }
        this.actual_num_overview = res.data.actual_num_overview;
        // this.loading = false
        // 文献分析
        let keyArrary = [];
        if (res.data.literature_summary) {
          this.hasFenxi = true;
          res.data.literature_summary.forEach((item) => {
            if (item.charts) {
              item.charts.forEach((items) => {
                items.chartData = {};
                if (item.section_name === "医学情报") {
                  keyArrary = [];
                  for (const name in items.data) {
                    keyArrary.push({ word: name, count: items.data[name] });
                  }
                  items.chartData["rows"] = keyArrary;
                  items.chartData["columns"] = ["word", "count"];
                } else {
                  items.chartData["rows"] = items.data;
                  items.chartData["columns"] = [items.ylab, items.xlab];
                }
              });
            }
          });
          this.chart = res.data.literature_summary;
          // console.log(this.chart)
        } else {
          this.hasFenxi = false;
        }
        // 文献概述
        if (res.data.literature_overview) {
          this.hasOver = true;
          res.data.literature_overview.forEach((item) => {
            this.titleJson[item.publication_time] = [];
            item.publications.forEach((items) => {
              items.translate = false;
              items.loading = false;
              // this.titleJson[item.publication_time].push(items.title)
              this.titleJson[item.publication_time].push({
                title: items.title,
                conclusions: items.major_conclusion,
              });
            });
            this.timeData[item.publication_time] = item.publications;
          });
        } else {
          this.hasOver = false;
        }
      } else {
        this.loading = false;
        this.num_summary = "";
        this.num_overview = "";
        this.hasData = false;
      }
    },
    progress(event) {
      const pro_percent = (event.loaded / event.total) * 100;
      this.percent = Number(pro_percent.toFixed(0));
      if (this.percent === 100) {
        setTimeout(() => {
          this.loading = false;
        }, 1000);
      }
    },
    // 翻译重点信息
    async translateFullText(pmid, key, index, translate) {
      let key_type = "";
      let current = this.timeData[key];
      current[index].loading = true;
      if (translate) {
        current[index].title = this.titleJson[key][index].title;
        current[index].major_conclusion = this.titleJson[key][
          index
        ].conclusions;
        key_type = "en_key";
      } else {
        key_type = "cn_key";
      }
      let ts = new Date().getTime();
      let tokenStr = `${this.clientId}.bz${ts}.bz${pmid}.bz${this.secret}`;
      let token = md5(tokenStr, 32);
      const params = {
        client_id: this.clientId,
        ts: Number(ts),
        pmid: String(pmid),
        types: key_type,
        token: token,
      };
      const res = await translateInfo(params);

      let Logger = webTrackerEvent();
      Logger.push("page_url", window.location.href);
      Logger.push("action", "translate");
      Logger.push("language", key_type);
      Logger.push("pmid", pmid);
      Logger.push("token", this.token);
      Logger.push("openid", this.openid);
      Logger.logger();

      if (res.data.status == 0) {
        if (!translate) {
          current[index].title = res.data.data.title;
          current[index].major_conclusion = res.data.data["sentence"][4][1];
          current[index].translate = true;
          current[index].loading = false;
          this.timeData[key] = current;

          this.timeData = Object.assign({}, this.timeData);
          return;
        }
        current[index].translate = false;
        current[index].loading = false;
        this.timeData[key] = current;

        this.timeData = Object.assign({}, this.timeData);
      }
    },
    // 查看全文
    showFullText(pmid) {
      let Logger = webTrackerEvent();
      Logger.push("page_url", window.location.href);
      Logger.push("action", "fullText");
      Logger.push("pmid", pmid);
      Logger.push("token", this.token);
      Logger.push("openid", this.openid);
      Logger.logger();
      this.$router.push("fullText?pmid=" + pmid);
    },
  },
  mounted() {
    this.keyword = this.$route.query.key;
    this.beforeNumFound = Number(this.$route.query.numFound);
    this.filter = JSON.parse(this.$route.query.filter);
    this.sortText = this.$route.query.sort;
    this.searchType = this.$route.query.searchType;
    this.title_word = this.keyword;
    console.log(this.$route.query);
    if(!Array.isArray(this.keyword) && this.searchType == 'advanced') {
      this.keyword = [this.keyword]
    }
    if (typeof this.keyword === "object") {
      this.title_word = this.keyword.join(" ");
    }
    if (this.$route.query.scope) {
      this.scope = JSON.parse(this.$route.query.scope);
    } else {
      this.scope = [];
    }
    this.getAnalysis();
  },
};
</script>

<style scoped>
.pubMedChart {
  background: #f9f9f9;
  min-height: 700px;
  padding-bottom: 50px;
}
.pubMedChart .content {
  width: 1080px;
  margin: 0 auto;
}
.pubMedChart .content .el-card__header span {
  margin-left: 18px;
  font-size: 16px;
  color: #333;
  font-weight: bold;
  margin-top: 10px;
}
.pubMedChart .content .el-card__header span em {
  font-size: 14px;
  color: #333;
  font-weight: normal;
}
.pubMedChart .content .el-card__header img {
  margin-top: 10px;
}
.pubMedChart .content .el-card .actualNum {
  margin-bottom: 10px;
  font-size: 13px;
  color: #333;
}
.pubMedChart .content .el-card .actualNum span {
  color: #336098db;
}
.content .introduce {
  margin-bottom: 40px;
}
.content .introduce h2.title {
  font-weight: normal;
  font-size: 16px;
  color: #333;
}
.content .introduce h2.title span {
  width: 6px;
  height: 24px;
  background: #4083d4;
  display: block;
}
.content .introduce h2.title em {
  margin-left: 10px;
  line-height: 24px;
}
.content .searchInput {
  font-size: 16px;
  color: #333;
}
.content .searchInput .el-input {
  width: 80px;
  margin-top: 5px;
  border: none;
  border: 1px solid #153d85;
  border-radius: 5px;
}
.content .searchButton {
  background: #387ed2;
  padding: 10px 40px;
  border-radius: 5px;
  font-size: 16px;
  color: #fff;
}
.content .introduce .info {
  line-height: 30px;
  margin-top: 10px;
}
.content .medInfo .el-row {
  border-bottom: 1px dashed #e2e2e2;
}
.content .medInfo .el-row .el-col {
  line-height: 40px;
}
.content .medInfo .el-row .el-col span {
  font-weight: bold;
}
.content .introduce .el-tabs {
  margin-top: 20px;
}
.content .introduce .el-badge {
  top: 0;
}
.pubMedChart .content .resultList ul li.infoLi {
  border-bottom: 1px dashed #ccc;
  margin-top: -1px;
  padding: 10px;
  position: relative;
  overflow: hidden;
}
.pubMedChart .content ul li.el-timeline-item {
  padding: 0;
  border: none;
  margin-bottom: 30px;
  margin-top: 20px;
  /* overflow:visible; */
}
.pubMedChart .content .resultList ul li.el-timeline-item p.timeLine {
  font-size: 14px;
  color: #333;
  padding-left: 24px;
  background: url("../assets/img/chart2.png") no-repeat 0 center;
  margin-bottom: 10px;
  height: 18px;
  line-height: 18px;
}
.pubMedChart .content .resultList .listTitle .title {
  font-size: 16px;
  color: #333;
  font-weight: bold;
}
.pubMedChart .content .resultList .listTitle .title .pptIcon {
  width: 20px;
  vertical-align: middle;
}
.pubMedChart .content .resultList .listInfo {
  margin-top: 10px;
}
.pubMedChart .content .resultList .listInfo .el-col {
  margin-bottom: 10px;
}
.pubMedChart .content .resultList .listInfo .el-col span {
  color: #387ed2;
}
.pubMedChart .content .resultList .el-col .showMore {
  margin-left: 10px;
  display: block;
  font-size: 14px;
  line-height: 30px;
}
.pubMedChart .content .resultList .el-col .translate {
  margin-left: 10px;
  display: block;
  font-size: 14px;
  line-height: 30px;
}
.pubMedChart ol.bullet_point li {
  font-size: 12px;
  color: #333;
  margin-bottom: 10px;
}
.pubMedChart ol.bullet_point li span {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #000;
  display: block;
  margin-top: 6px;
}
.pubMedChart ol.bullet_point li em {
  margin-left: 10px;
  width: 90%;
  line-height: 20px;
}
.pubMedChart .introduce p.keyType {
  font-size: 14px;
  color: #333;
  font-weight: bold;
}
.pubMedChart .noData {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.pubMedChart .noData img {
  display: block;
  margin: 0 auto;
}
.pubMedChart .noData span {
  display: block;
  text-align: center;
  font-size: 14px;
  color: #ccc;
  margin-top: 10px;
}
.pubMedChart .progressBox {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 11;
}
.pubMedChart .progressBox .shadow {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(31, 31, 31, 0.7);
}
/* .pubMedChart .progressBox .el-progress{ */
/* width:600px;
        position: absolute;
        top:50%;
        left:50%;
        transform: translate(-50%, -50%) */
/* } */
</style>
<style>
.content .introduce .el-tabs--border-card > .el-tabs__header {
  background-color: #f5fcff;
  border-bottom-color: #49b1d8;
  margin-left: 1px;
}
.content .introduce .el-tabs--border-card {
  box-shadow: none;
  border: 1px solid #49b1d8;
  border-right: none;
  border-left: none;
  border-top: none;
}
.content
  .introduce
  .el-tabs--border-card
  > .el-tabs__header
  .el-tabs__item.is-active {
  border-right-color: #49b1d8;
  border-left-color: #49b1d8;
  border-top-color: #49b1d8;
  border-bottom: none;
}
.content .introduce .el-tabs--border-card > .el-tabs__header .el-tabs__item {
  border-bottom-color: #49b1d8;
  color: #333;
  font-weight: normal;
}
.content .introduce .el-tabs--border-card > .el-tabs__content {
  border-right: 1px solid #49b1d8;
  border-left: 1px solid #49b1d8;
}
.content .introduce .el-tabs__nav {
  float: none;
}
.content .introduce .el-tabs__nav-wrap {
  overflow: visible;
}
.content .introduce .el-tabs__nav-scroll {
  overflow: visible;
}
/* .pubMedChart .content ul li.el-timeline-item .el-timeline-item__wrapper{
    padding: 0 !important
} */
/* .pubMedChart .content .el-timeline-item__node--normal{
    left:-21px;
}*/
.pubMedChart .content .el-timeline-item__tail {
  height: 105%;
  border: 1px solid #56b6db;
}
.pubMedChart .progressBox .el-progress .el-progress-bar {
  vertical-align: top;
}
</style>


// WEBPACK FOOTER //
// src/views/pubMedChart.vue